export default __webpack_public_path__ + "static/media/iconCopyDark.4954f8a3.svg";